export const copyTotalSeriesIntoRowsSeriesVisitor = () => (args) => {
    if (args.visitable?.length) {
        const newVisitables = [];
        args.visitable.forEach((v) => {
            newVisitables.push({ ...v, series: [...v?.series || []].concat(v?.totals || []) });
        });
        args.visitable = newVisitables;
    }
};
